export default "__VITE_ASSET__C23kM44w__"